import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Wrapper } from 'js/components/system/Wrapper';
import { Maintenance } from 'js/components/system/Maintenance';

import { PlaytechVariables } from './components/PlaytechVariables';

export const WrapperRouter = () => (
    <BrowserRouter>
        <PlaytechVariables>
            <Maintenance>
                <HelmetProvider>
                    <Wrapper />
                </HelmetProvider>
            </Maintenance>
        </PlaytechVariables>
    </BrowserRouter>
);
